export const LogoShape = {
	landscape: 'landscape',
	portrait: 'portrait',
	square: 'square',
};
